import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const titles = { '/': 'Оценка коммерческой недвижимости', '/home': 'Оценка коммерческой недвижимости', '/services': 'Возможности', '/analytics': 'Аналитика', '/about': 'О проекте', '/contacts': 'Контакты', '/login': 'Вход', '/register': 'Регистрация', '/forgot-password': 'Восстановление доступа', '/reset-password': 'Новый пароль', '/personal': 'Личный кабинет' };

export default function RouteEffects() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    document.title = `${titles[pathname] || 'Платформа'} — ЗЕМА`;
  }, [pathname]);
  return null;
}
